import moment from "moment";

import {
    SURVEYACTIVITYV3SCREEN_LOAD,
    SURVEYACTIVITYV3SCREEN_UNLOAD,
    SURVEYACTIVITYV3SCREEN_SET,
} from '../../../actionDefinitions';

import {
    fetchAllInteractions,
    fetchSurveysCount,
    fetchProgressOverTimeStatsByTeam,
    fetchRfcBreakdown,
    fetchChannelBreakdown,
    fetchResponseBreakdown,
    fetchInteractionsReport,
    fetchCustomerInteractionsReport,
    fetchPilotReport,
    fetchCustomerInteractionsReportBySurveyDate,
    fetchUsersStats
} from '../../../api/v3/SurveyActivityV3Api';

import {
    fetchTicketCountOverTimeStats,
    fetchTicketCountOverTimeStatsForUsers,
} from '../../../api/v3/SystemDashboardV3Api';

import {
    fetchChannels,
    fetchReasonsForContact,
    fetchCalibratedOnSurveyQuestions,
    fetchUserTeamsStats,
    fetchDomainValues
} from '../../../api/v3/DataApi';

import {
    SurveyType
} from '../../../generated';
import { timePeriodicityOptions } from '../../../constants';
import { isDefined } from "../../../utils";

export function loadSurveyActivityBasicData() {
    return dispatch => {
        dispatch(loadUserTeamsStats());
        dispatch(loadChannels());
        dispatch(loadUsersStats());
        dispatch(loadCalibratedOnSurveyQuestions());
        dispatch(loadDomainValues());
    };
}

export function loadSurveyActivityV3ManagerScreen(fromDate, toDate, selectedTimePeriodicity,
    selectedFilters, userId, surveyTypeId) {
    return dispatch => {
        dispatch(loadTicketCountOverTimeStats(fromDate, toDate, selectedTimePeriodicity, selectedFilters, userId));
        dispatch(loadProgressOverTimeStatsByTeam(timePeriodicityOptions[0].id, fromDate, toDate));


        dispatch(loadAllInteractions(fromDate, toDate));
        dispatch(loadRfcBreakdown(fromDate, toDate, selectedFilters));
        dispatch(loadChannelBreakdown(fromDate, toDate, selectedFilters));
        dispatch(loadResponseBreakdown(surveyTypeId, fromDate, toDate, selectedFilters));
    };
}

export function loadAllInteractions(fromDate, toDate) {
    return dispatch =>
        fetchAllInteractions(fromDate, toDate)
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { allInteractions: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadDomainValues() {
    return dispatch =>
        fetchDomainValues()
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { domainValues: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadChannels() {
    return dispatch =>
        fetchChannels()
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { channels: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadInteractionsReport(fromDate, toDate) {
    return dispatch =>
        fetchInteractionsReport(fromDate, toDate)
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { interactionReport: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadCustomerInteractionsReport(fromDate, toDate) {
    return dispatch =>
        fetchCustomerInteractionsReport(fromDate, toDate)
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { isDownloadingReport: false } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload: { isDownloadingReport: false } }))
}

export function loadCustomerInteractionsReportBySurveyDate(fromDate, toDate) {
    return dispatch =>
        fetchCustomerInteractionsReportBySurveyDate(fromDate, toDate)
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { isDownloadingReport: false } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload: { isDownloadingReport: false } }))
}

export function loadRfcBreakdown(fromDate, toDate, selectedFilters) {
    return dispatch =>
        fetchRfcBreakdown(fromDate, toDate, selectedFilters)
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { rfcBreakdown: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadChannelBreakdown(fromDate, toDate, selectedFilters) {
    return dispatch =>
        fetchChannelBreakdown(fromDate, toDate, selectedFilters)
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { channelBreakdown: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadResponseBreakdown(surveyTypeId, fromDate, toDate, selectedFilters) {
    return dispatch =>
        fetchResponseBreakdown(surveyTypeId, fromDate, toDate, selectedFilters)
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { responseBreakdown: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadTicketCountOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters, userId) {
    if (isDefined(userId)) {
        return dispatch =>
            fetchTicketCountOverTimeStatsForUsers(fromDate, toDate, timePeriodicity, selectedFilters, userId)
                .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { ticketCountOverTimeStats: payload.result } }))
                .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
    }
    else {
        return dispatch =>
            fetchTicketCountOverTimeStats(fromDate, toDate, timePeriodicity, selectedFilters)
                .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { ticketCountOverTimeStats: payload.result } }))
                .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
    }
}

export function loadProgressOverTimeStatsByTeam(timePeriodicity, fromDate, toDate, reasonForContactId, channelId, agentId) {
    return dispatch =>
        fetchProgressOverTimeStatsByTeam(timePeriodicity, fromDate, toDate, reasonForContactId, channelId, agentId)
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { progressOverTimeStatsByTeam: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadCalibratedOnSurveyQuestions() {
    return dispatch =>
        fetchCalibratedOnSurveyQuestions()
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { calibratedOnSurveyQuestions: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadUserTeamsStats() {
    return dispatch =>
        fetchUserTeamsStats()
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { userTeamsStats: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function loadUsersStats() {
    return dispatch =>
        fetchUsersStats()
            .then(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, payload: { usersStats: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYACTIVITYV3SCREEN_LOAD, error: true, payload }))
}

export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: SURVEYACTIVITYV3SCREEN_SET, updatedProps });
    }
}

